import { MMLabelValue as LibraryLabelValue } from 'mmfintech-portal-commons'
import type { MMLabelValueProps } from 'mmfintech-portal-commons/types'

type LabelValueVariant = 'primary' | 'withdrawal'

export const MMLabelValue = (props: MMLabelValueProps<LabelValueVariant>) => <LibraryLabelValue {...props} />
